<template>
  <div class="pageDiv">
    <v-card class="no-login" v-if="!$AuthSvc.isLogin() || !$AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Handicap Admin</span>
      </v-card-title>

      Must login as ADMIN to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin() && $AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Handicap Admin ({{displayMembers.length}})</span>
      </v-card-title>
      <v-card>
        <div class="action-card">
            <a :class="{actionBusy: running}" class="primary-btn action-buttons" @click="assignCourse()">Assign Course</a>
            <a :class="{actionBusy: running}" class="primary-btn action-buttons" @click="calculateHandicap()">Calc HCP</a>
            <a :class="{actionBusy: running}" class="primary-btn action-buttons" @click="calculatePlayersHandicap()">Calc Players HCP</a>
            <a :class="{actionBusy: running}" class="primary-btn action-buttons" @click="saveAll()">Save All</a>
        </div>
        <v-card-text class="filterCard">
            <span class="label12">Filter:</span> 
            <v-card-text>
                <input type="checkbox" class="checkBox" v-model="isEdit"> <span class="checkboxLbl">Edit</span>
                <input type="checkbox" class="checkBox" @click="isMember=!isMember;filter();"> <span class="checkboxLbl">Member?</span>
                <input type="checkbox" class="checkBox" @click="noZero=!noZero;filter();"> <span class="checkboxLbl">No Zeros</span>
                <input type="checkbox" class="checkBox" @click="east=!east;filter();"> <span class="checkboxLbl">EAST</span>
                <input type="checkbox" class="checkBox" @click="west=!west;filter();"> <span class="checkboxLbl">WEST</span>
            </v-card-text>
            <v-card-text class="filterSubCard">
                <v-card-text class="oneFilterCard">
                  HCP Range: <input class="smallInput" v-model="lowRange"/> <input class="smallInput" style="margin-left: 7px" v-model="highRange"/>
                  <input type="checkbox" class="checkBox" style="vertical-align: bottom" @click="hcpRange=!hcpRange;filter();">
                   <span class="checkboxLbl">Show</span>
                </v-card-text>
            </v-card-text>
            
        </v-card-text>
      </v-card>

      <v-card class="p-card">
        <v-card-text class="">
          <v-simple-table class="simple-table">
            <tr>
              <th width="10px">#</th>
              <th v-if="isEdit"></th>
              <th>Name</th>
              <th>LOC</th>
              <th>Flt</th>
              <th>Rnds</th>
              <th width="10px">
                <a class="sortLink" @click="sort('hcp')">Override HCP</a>
              </th>
              <th>
                <a class="sortLink" @click="sort('dfwvga')">DFWVGA HCP</a>
              </th>
            </tr>
            <tr  v-for="(player, index) in displayMembers" :key="player">
              <td  :class="{changedData: player.isChanged}" >{{index+1}}</td>
              <td v-if="isEdit">
                <button @click="save(player.player)" class="primary-btn" style="padding:2px;">
                  <span class="lbl10">Save</span>
                </button>
              </td>
              <td>{{player.player.firstName}} {{player.player.middleName}} {{player.player.lastName}}
                <v-img class="member-logo" v-if="player.membership" src="../../assets/img/dfwvga-logo-mini.png">
                </v-img>
              </td>
              <td >
                <select v-if="isEdit" class="dropdown" v-model="player.player.proximity" @change="player.isChanged=true">
                  <option value="">None</option>
                  <option value="EAST">EAST</option>
                  <option value="WEST">WEST</option>
                </select>
                <span v-if="!isEdit">
                  {{ $AuthSvc.locI(player.player.proximity) }}
                </span>
              </td>
              <td>
                <select v-if="isEdit" class="dropdown" v-model="player.player.defaultFlight" @change="player.isChanged=true">
                  <option value="Nicklaus">Nicklaus</option>
                  <option value="Palmer">Palmer</option>
                  <option value="Hogan">Hogan</option>
                </select>
                <span v-if="!isEdit">
                  {{ $AuthSvc.fltI(player.player.defaultFlight) }}
                </span>
              </td>
              <td>{{player.player.hcpRounds}}</td>
              <td>
                <input v-if="isEdit" class="dfwvga-btn" style="width:60px" v-model="player.player.handicap"
                       @change="player.isChanged=true" @keypress="player.isChanged=true"/>
                <span v-if="!isEdit">
                  {{ player.player.handicap }}
                </span>
              </td>
              <td>{{getScoreHcp(player.player.dfwvgaHandicap)}}</td>
            </tr>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      memberPlayers: [],
      displayMembers: [],
      isMember: false,
      noZero: false,
      east: false,
      west: false,
      running: false,
      isEdit: false,
      hcpRange: false,
      lowRange: -10.0,
      highRange: 100.0,
      withNoHcp: false
    }),
    mounted: function() {
      this.$AuthSvc.authenticated(this.loadPlayers);
    },
    methods: {
      loadPlayers() {
        var _this = this;

        this.axios.get('/admin/filter-players')
        .then(function (response) {
            _this.memberPlayers = response.data;
            for(var i=0; i < _this.memberPlayers.length; i++) {
              if (_this.memberPlayers[i].player.handicap !== null &&
                  _this.memberPlayers[i].player.handicap !== '' &&
                  _this.memberPlayers[i].player.handicap !== '0') {
                _this.memberPlayers[i].player.diff =
                    _this.memberPlayers[i].player.dfwvgaHandicap - _this.memberPlayers[i].player.handicap;
              } else {
                _this.memberPlayers[i].player.diff = '';
              }
              _this.memberPlayers[i].player.isChanged = false;
            }
            _this.displayMembers = _this.memberPlayers
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
      },
      getScoreHcp(scoreHcp) {
        if (scoreHcp === '' || scoreHcp > 60.00) {
          return "";
        }
        else {
          return Number(scoreHcp).toFixed(2);
        }
      },
      sort(field) {
        if (field === 'hcp') {
            this.displayMembers.sort((a, b) => ( a.player.handicap > b.player.handicap ) ? 1 : -1);
            this.pushDNPBottom();
        }
        else if (field === 'dfwvga') {
            this.displayMembers.sort((a, b) => ( a.player.dfwvgaHandicap > b.player.dfwvgaHandicap ) ? 1 : -1);
        }
        else if (field === 'diff') {
            this.displayMembers.sort((a, b) => ( a.player.diff > b.player.diff ) ? 1 : -1);
        }
      },
      assignCourse() {
        var _this = this;
        if ( !_this.running ) {
          _this.running = true;
          this.axios.get('/admin/scores/assign-course')
          .then(function (response) {
            console.log("COMPLETE Successfully " + response.data);
            _this.running = false;
            swal("Success", "Assign course completed successfully.", "info");
          })
          .catch(function (error) {
            console.log('ERROR: ' + error);
            _this.running = false;
            swal("Error", "Assign course failed.", "error");
          });
        }
      },
      calculateHandicap() {
        var _this = this;
        if ( !_this.running ) {
          _this.running = true;
          this.axios.get('/admin/scores/calculate-handicap')
          .then(function (response) {
            console.log("COMPLETE Successfully " + response.data);
            _this.running = false;
            swal("Success", "Calculate score handicap completed successfully.", "info");
          })
          .catch(function (error) {
            console.log('ERROR: ' + error);
            _this.running = false;
            swal("Error", "Calculate score handicap failed.", "error");
          });
        }
      },
      calculatePlayersHandicap() {
        var _this = this;
        if ( !_this.running ) {
          _this.running = true;
          this.axios.get('/admin/scores/calculate-players-handicap')
          .then(function (response) {
            console.log("COMPLETE Successfully " + response.data);
            _this.running = false;
            swal("Success", "Calculate players handicap completed successfully.", "info");
          })
          .catch(function (error) {
            console.log('ERROR: ' + error);
            _this.running = false;
            swal("Error", "Calculate players handicapÏ failed.", "error");
          });
        }
      },
      hasFilter() {
        return (this.isMember || this.noZero || this.east || this.west) || this.hcpRange;
      },
      filter() {
        var _this = this;

        if (this.hasFilter()) {
          var filterList = _this.memberPlayers;

          if ( _this.isMember ) {
            filterList = filterList.filter(function(player){return player.membership;});
          }

          if ( _this.east ) {
            filterList = filterList.filter(function(player){return player.player.proximity==='EAST';});
          }

          if ( _this.west ) {
            filterList = filterList.filter(function(player){return player.player.proximity==='WEST';});
          }

          if ( _this.noZero ) {
            filterList = filterList.filter(function(player){return player.player.dfwvgaHandicap < 100;});
          }

          if ( _this.hcpRange ) {
            filterList = filterList.filter(function(player)
            {
              if (player.player.dfwvgaHandicap != null && player.player.dfwvgaHandicap != '') {
                return player.player.dfwvgaHandicap >= _this.lowRange && player.player.dfwvgaHandicap <= _this.highRange;
              }
              return false;
            });
          }

          this.displayMembers = filterList;
        } else {
          this.displayMembers = this.memberPlayers
        }
      },
      saveAll() {
        var _this = this;
        if ( !_this.running ) {
          _this.running = true;
          var i;
          for(i=0; i < _this.displayMembers.length; i++) {
            if (_this.displayMembers[i].isChanged) {
              console.log('UPDATING... ' + _this.displayMembers[i].player.firstName);
              _this.save(_this.displayMembers[i].player);
            }
          }
          _this.running = false;
        }
      },
      async save(player) {
          console.log("Save handicap");
          var request = {
            flight: player.defaultFlight,
            handicap: player.handicap,
            proximity: player.proximity
          };

          await this.axios.post('/admin/players/' + player.playerId+ '/update-handicap', request)
          .then(function (response) {
              swal("Success", "Save handicap successfully.", "info")
          })
          .catch(function (error) {
              console.log('ERROR: ' + error);
          });
      }
    }
  }

</script>

<style scoped>

  .member-logo {
    display: inline-block;
    height: 20px;
    width: 20px;
    border-radius: 45px;
    margin-left: 10px;
  }

  .primary-btn {
    border-radius: 5px;
  }

  .sortLink {
    color: yellow;
  }

  .action-card {
      display: inline-block;
      height: 60px;
      width: 100%;
      padding: 7px;
  }

  .action-buttons {
      display: inline-block;
      margin-right: 3px;
      padding: 2px 5px;
      border: 2px solid black;
      border-radius: 7px;
  }

  .actionBusy {
     background-color: lightgrey !important;
     color: darkgray !important;
     cursor: wait;
     border: 2px solid darkgray !important;
  }

  .changedData {
    background-color: lightgray;
  }

  .filterCard {
    display: inline-block;
    width: 100%;
  }

  .filterSubCard {
    display: inline-block;
    width: 80%;
    margin-left: 15px;
    margin-top: 7px;
  }

  .oneFilterCard {
    display: inline-block;
    width: 80%;
    margin-top: 7px;
  }

  .smallInput {
    width: 40px;
    background-color: white;
    border: 1x black solid;
  }

  .checkBox {
    width: 20px;
    height: 20px;
    margin-left: 10px;         
  }

  .checkboxLbl {
    display: inline-block;
    vertical-align: top;
    margin-left: 5px;
  }

  @media (min-width: 768px) {
    .action-buttons {
        margin-right: 10px;
        float: left;
    }

    td {
      font-size: 14px;
      font-weight: bold;
    }
  }

</style>